import { render, staticRenderFns } from "./SalePricesUnitFilter.vue?vue&type=template&id=50edb656"
import script from "./SalePricesUnitFilter.vue?vue&type=script&lang=js"
export * from "./SalePricesUnitFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports